import React from 'react';

export const inlineImageRules = [
  {
    deserialize(el, next) {
      if (el.tagName.toLowerCase() === 'img') {
        const src = el.getAttribute('src');
        const attachmentId = el.getAttribute('data-attachment-id');
        return { object: 'block', type: 'image', nodes: next(el.childNodes), data: { src, attachmentId } };
      }
    },
    serialize(object, children) {
      if (object.object === 'block' && object.type === 'image') {
        const src = object.data.get('src');
        const attachmentId = object.data.get('attachmentId');
        return <img src={src} data-attachment-id={attachmentId} />;
      }
    },
  },
];



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/serializers/rules/inline_image_rules.jsx